import dashDefinitions from './index'
import { TRUCK_SUBTYPE_42N } from 'utils/constants'

const DB_CODE_TO_PANEL_TYPE = {
  '4E1-998': 'overhead',
  '4E1-001': 'overhead',
  '4E1-002': 'overhead',
  '4E1-003': 'overhead',
  '4E1-004': 'overhead',
  '4E1-005': 'overhead',
  '4E1-006': 'overhead',
  '4E1-007': 'overhead',
  '4E1-008': 'overhead',
  '4E1-009': 'overhead',
  '4E1-010': 'overhead',
  '4E1-011': 'overhead',
  '4E1-012': 'overhead',
  '4E1-014': 'overhead',
  '4E1-015': 'overhead',
  '4E1-016': 'overhead',
  '4E1-017': 'overhead',
  '4E1-018': 'overhead',
  '35M-001': 'overhead',
  '35M-002': 'overhead',
  '35M-003': 'overhead',
  '35M-004': 'overhead',
  '35M-005': 'overhead',
  '35M-006': 'overhead',
  '35M-007': 'overhead',
  '35M-008': 'overhead',
  '35M-009': 'overhead',
  '682-090': 'sleeper',
  '682-091': 'sleeper',
  '682-092': 'sleeper',
  '682-088': 'sleeper',
  '682-093': 'sleeper',
  '682-094': 'sleeper',
}

const DAY_CAB_CODES = ['829-071', '829-072', '829-1A5', '829-1A2']
const EXTENDED_CAB_CODES = [
  '829-075',
  '829-076',
  '829-079',
  '829-080',
  '829-1A6',
  '829-1A7',
  '829-1A3',
  '829-1A4',
]

// Returns { overhead?, sleeper? } — each value is a definition object from the
// definitions registry. Mirrors the same logic as getOverheadAndSleeperDefinitions
// in reducers/dash.js so snapshots and the live S&G panel use identical rules.
export const resolveOverheadSleeperDefinitions = (
  vehicleSubType,
  dataBookCodes
) => {
  if (!dataBookCodes || !dataBookCodes.length) return {}

  return dataBookCodes.reduce((acc, curr) => {
    const typeKey = DB_CODE_TO_PANEL_TYPE[curr]
    if (!typeKey) return acc

    const hasDefinition = Boolean(
      dashDefinitions[curr] ||
        dashDefinitions[`${curr}_DAY`] ||
        dashDefinitions[`${curr}_EXTENDED`]
    )
    if (!hasDefinition) return acc

    if (vehicleSubType === TRUCK_SUBTYPE_42N && curr.includes('4E1-')) {
      if (DAY_CAB_CODES.some((c) => dataBookCodes.includes(c))) {
        return { ...acc, [typeKey]: dashDefinitions[`${curr}_DAY`] }
      }
      if (EXTENDED_CAB_CODES.some((c) => dataBookCodes.includes(c))) {
        return { ...acc, [typeKey]: dashDefinitions[`${curr}_EXTENDED`] }
      }
    }

    if (dashDefinitions[curr]) {
      return { ...acc, [typeKey]: dashDefinitions[curr] }
    }

    return acc
  }, {})
}
